import { render, staticRenderFns } from "./SentEmails.vue?vue&type=template&id=5fb7d3e6&scoped=true&"
import script from "./SentEmails.vue?vue&type=script&lang=js&"
export * from "./SentEmails.vue?vue&type=script&lang=js&"
import style0 from "./SentEmails.vue?vue&type=style&index=0&id=5fb7d3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb7d3e6",
  null
  
)

export default component.exports